import { getRootDomain } from "PFCore/helpers/root_domain";

const ROOT = "account";

export const accountKeys = {
  single: (domain) => [ROOT, domain],
  current: () => accountKeys.single(getRootDomain())
};
